/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { StateResource } from '@common/tech-shared';
import { UserProfileResource } from '@alfa-client/user-profile-shared';
import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  QueryList,
  ViewChild,
} from '@angular/core';
import { SearchResultItemComponent } from '@ods/system';
import { UserProfileSearchResultsContainerComponent } from './user-profile-search-results-container/user-profile-search-results-container.component';
import { UserProfileSearchFormService } from './user-profile-search.formservice';

@Component({
  selector: 'alfa-user-profile-search',
  templateUrl: './user-profile-search.component.html',
  standalone: false,
  providers: [UserProfileSearchFormService],
})
export class UserProfileSearchComponent implements AfterViewChecked {
  public readonly formService = inject(UserProfileSearchFormService);
  private readonly cdr = inject(ChangeDetectorRef);

  @Input() public initials: string;
  @Input() public userSearchResults: StateResource<UserProfileResource>[];
  @Input() set userProfile(value: StateResource<UserProfileResource>) {
    this._userProfile = value;
    this.showUnassigned = Boolean(this._userProfile.resource);
  }

  @Output() public searched: EventEmitter<string> = new EventEmitter();

  @ViewChild(UserProfileSearchResultsContainerComponent) resultsContainerComp: UserProfileSearchResultsContainerComponent;

  _userProfile: StateResource<UserProfileResource>;
  public showUnassigned: boolean;
  public searchResultItemList: QueryList<SearchResultItemComponent>;
  public readonly formServiceClass = UserProfileSearchFormService;

  ngAfterViewChecked() {
    this.searchResultItemList = this.resultsContainerComp?.resultsComp?.searchResultItemList;
    this.cdr.detectChanges();
  }

  handleSearchQueryChanged(searchBy: string) {
    this.showUnassigned = Boolean(this._userProfile.resource) && 'nicht zugewiesen'.includes(searchBy.toLowerCase());
    this.searched.emit(searchBy);
  }
}
